import SelfPickUpForm from './SelfPickUpForm';
import DeliveryServiceForm from './DeliveryServiceForm';
import AddProductForm from './AddProductForm';

export default {
  SelfPickUpForm,
  DeliveryServiceForm,
  AddProductForm,
};



// WEBPACK FOOTER //
// ./src/components/forms/index.js